var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trial-rating-label",class:{vertical: _vm.isVerticalLabel, [_vm.labelStyle]: true}},_vm._l((_vm.choices),function(choice,index){return _c('div',{key:`label-${index}`,staticClass:"label"},[_c('div',{staticClass:"color"}),_c('span',[_vm._v(_vm._s(choice.id)+" : "+_vm._s(choice.text))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }